import React, { useState } from "react";

export default function InternationalShipping() {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;

    setTimeout(() => {
      setLoading(false);
      setDone(true);
      form.reset();
      setTimeout(() => setDone(false), 3000);
    }, 1500);
  };

  return (
    <>
      {/* ⭐ INLINE CSS */}
      <style>{`
        .banner {
          height: 350px;
          background: url('/slider2.jpg') center/cover no-repeat;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-align: center;
        }

        .banner::after {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.55);
        }

        .banner h1 {
          z-index: 2;
          font-size: 50px;
          font-weight: 800;
        }

        .section {
          padding: 90px 0;
        }

        .glass-card {
          background: rgba(255,255,255,0.9);
          backdrop-filter: blur(12px);
          padding: 40px;
          border-radius: 22px;
          box-shadow: 0 12px 35px rgba(0,0,0,0.12);
          border: 1px solid rgba(0,0,0,0.08);
          animation: fadeUp 1s ease;
          margin-bottom: 60px;
        }

        .title {
          font-size: 34px;
          font-weight: 800;
          margin-bottom: 20px;
          position: relative;
        }

        .title::after {
          content: "";
          width: 90px;
          height: 5px;
          background: linear-gradient(90deg, #005eff, #f80b0b);
          position: absolute;
          bottom: -8px;
          left: 0;
          border-radius: 5px;
        }

        .text {
          font-size: 17px;
          color: #444;
          line-height: 1.9;
          margin-bottom: 18px;
        }

        .feature-box {
          padding: 22px;
          border-radius: 15px;
          background: white;
          box-shadow: 0px 10px 25px rgba(0,0,0,0.12);
          border-left: 6px solid #005eff;
          margin-bottom: 20px;
        }

        .shipping-form {
          background: white;
          padding: 45px;
          border-radius: 20px;
          box-shadow: 0px 18px 40px rgba(0,0,0,0.12);
          border: 1px solid rgba(0,0,0,0.06);
          animation: fadeUp 1s ease;
          margin-top: 70px;
        }

        .form-label {
          font-weight: 600;
          margin-bottom: 6px;
          color: #2b2b2b;
        }

        .form-control-custom,
        .form-select-custom {
          width: 100%;
          padding: 14px;
          border-radius: 12px;
          border: 1px solid #cfd6ff;
          font-size: 15px;
          transition: 0.25s ease;
        }

        .form-control-custom:focus,
        .form-select-custom:focus {
          border-color: #005eff;
          box-shadow: 0 0 8px rgba(0,94,255,0.35);
          outline: none;
        }

        .submit-btn {
          width: 100%;
          padding: 16px;
          background: linear-gradient(90deg, #005eff, #003fc8);
          color: #fff;
          font-size: 18px;
          font-weight: 700;
          border: none;
          border-radius: 14px;
          transition: 0.3s ease;
        }

        .submit-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0px 12px 22px rgba(0,94,255,0.35);
        }

        .loading-text {
          margin-top: 12px;
          color: #005eff;
          font-weight: 600;
        }

        .success-text {
          margin-top: 12px;
          color: green;
          font-weight: 600;
        }

        .faq-box {
          background: #f8f9ff;
          padding: 18px;
          border-radius: 12px;
          margin-bottom: 12px;
          border-left: 4px solid #005eff;
        }

        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(25px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* ⭐ BANNER */}
      <div className="banner">
        <h1>International Shipping</h1>
      </div>

      {/* ⭐ MAIN SECTION */}
      <section className="section">
        <div className="container">

          {/* ⭐ OVERVIEW */}
          <div className="glass-card">
            <h2 className="title">Global Freight Solutions to 220+ Countries</h2>

            <p className="text">
              International shipping is one of the most complex areas of logistics — involving customs 
              regulations, air & ocean freight coordination, multi-country compliance, carrier management, 
              routing intelligence, and constant communication.
              <br /><br />
              At SWIFTSHIP, we simplify the entire global shipping process with our advanced logistics 
              infrastructure, worldwide carrier partnerships, and an experienced team trained in U.S. export 
              and international trade regulations.
            </p>

            <p className="text">
              Whether you’re shipping small parcels, commercial freight, high-value items, machinery, 
              or bulk cargo — SWIFTSHIP ensures seamless global movement from the U.S. to any major 
              port or airport across Europe, Asia, Middle East, Africa, Oceania, Canada, Mexico, and more.
            </p>

            <p className="text">
              With transparent pricing, full compliance handling, and real-time global tracking — 
              your international logistics operations run smoother, faster, and more predictably.
            </p>
          </div>

          {/* ⭐ FEATURES */}
          <h2 className="title">International Shipping Capabilities</h2>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Air Freight – Fastest Global Delivery</h5>
            <p className="text">
              For urgent shipments, our air freight network provides rapid global delivery with priority 
              handling, guaranteed space, and customs-ready documentation for smooth border clearance.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Ocean Freight – Cost-Effective for Bulk Cargo</h5>
            <p className="text">
              SWIFTSHIP offers FCL & LCL shipping to all major sea ports worldwide. Perfect for heavy, 
              high-volume, or containerized goods requiring cost-efficient movement.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Customs Clearance & Documentation</h5>
            <p className="text">
              Our compliance specialists handle commercial invoices, HS codes, export declarations, 
              certificates, ISF filings, country-specific requirements, and duty/tax management — 
              eliminating the risk of delays.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Global Tracking & Live Status Updates</h5>
            <p className="text">
              Track your shipment across continents with GPS-enabled updates, milestone scans, port 
              events, and customs clearance checkpoints.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Worldwide Delivery Network</h5>
            <p className="text">
              We connect U.S. businesses to over 220 countries with trusted carriers, 
              international forwarding agents, and port/airport partners.
            </p>
          </div>

          {/* ⭐ INDUSTRIES */}
          <h2 className="title mt-5">Industries We Support Globally</h2>

          <p className="text">SWIFTSHIP serves a wide range of industries including:</p>

          <ul className="text">
            <li>✔ E-commerce & Cross-Border Retail</li>
            <li>✔ Electronics & High-Tech Manufacturing</li>
            <li>✔ Medical Equipment & Pharmaceuticals</li>
            <li>✔ Automotive Parts & Industrial Machinery</li>
            <li>✔ Fashion & Apparel Exporters</li>
            <li>✔ Oil, Gas & Industrial Equipment</li>
            <li>✔ Agricultural & Perishable Goods</li>
            <li>✔ Luxury Goods & High-Value Shipments</li>
          </ul>

          {/* ⭐ FAQ */}
          <h2 className="title mt-5">International Shipping FAQs</h2>

          <div className="faq-box">
            <strong>Q: How long does international shipping take?</strong>
            <p className="text">Air freight: 2–7 days. Ocean freight: 12–45 days depending on destination.</p>
          </div>

          <div className="faq-box">
            <strong>Q: Do you provide door-to-door delivery?</strong>
            <p className="text">Yes. We offer door-to-door, port-to-port, and door-to-port options.</p>
          </div>

          <div className="faq-box">
            <strong>Q: Can you handle customs clearance?</strong>
            <p className="text">Absolutely. Our compliance team handles all U.S. export and foreign import requirements.</p>
          </div>

          <div className="faq-box">
            <strong>Q: Do you ship hazardous or restricted items?</strong>
            <p className="text">Yes, but subject to international regulations (IATA, IMO, etc.).</p>
          </div>

          {/* ⭐ PREMIUM FORM */}
          <form className="shipping-form" onSubmit={handleSubmit}>
            <h3 className="fw-bold mb-4">Request an International Shipping Quote</h3>

            <div className="row g-3">

              <div className="col-md-6">
                <label className="form-label">Full Name</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Phone Number</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Email Address</label>
                <input type="email" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Origin Country</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Destination Country</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Shipment Weight (lbs/kg)</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Type of Shipment</label>
                <select className="form-select-custom" required>
                  <option value="">Select Type</option>
                  <option>Air Freight</option>
                  <option>Ocean Freight</option>
                  <option>Express Courier</option>
                  <option>High-Value Cargo</option>
                  <option>Dangerous Goods</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">Delivery Preference</label>
                <select className="form-select-custom" required>
                  <option value="">Select Option</option>
                  <option>Door to Door</option>
                  <option>Door to Port</option>
                  <option>Port to Port</option>
                  <option>Port to Door</option>
                </select>
              </div>

              <div className="col-12">
                <label className="form-label">Additional Instructions</label>
                <textarea className="form-control-custom" rows="4"></textarea>
              </div>

            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Submitting..." : "Submit Request"}
            </button>

            {loading && <div className="loading-text">Please wait...</div>}
            {done && <div className="success-text">Your request has been submitted successfully!</div>}
          </form>

        </div>
      </section>
    </>
  );
}
